import http from "../../services/http";

const getClassificacoes = async () => {
  return await http("get", `v1/classificacoes/listar`, []);
};

export { getClassificacoes };
